<template>
  <div>
    <div class="baner">
      <img src="../assets/Rectangle66.png" alt="">
    </div>
    <div class="contier-1">
      <div class="img-a inline">
        <img src="../assets/01.png" alt="">
      </div>
      <p class="title">南省高铁教育龙头单位，培训机制健全</p>
      <div class="img-a">
        <img src="../assets/Frame4.png" alt="">
      </div>
    </div>
    <div class="contier-2">
      <div class="left">
        <img src="../assets/Rectangle70.png" alt="">
      </div>
      <div class="right">
        <span>
          建校70年来，共培养中、高等技术应用型和管理型人才16万人，为国家轨道交通建设和经济社会发展提供了有力的人力支撑和智力支持。学校是河南省教育厅与中铁郑州局集团唯一共建院校,牵头组建了郑州铁路高等职业教育集团，与郑州地铁集团共建郑州市轨道交通人才培养基地,与46家企业和2家高校共同组建了河南省轨道交通产业技术创新战略联盟，当选黄河流域职业教育联盟副理事长单位。
        </span>
      </div>
    </div>
    <div class="contier-3">
      <div class="img-a inline">
        <img src="../assets/02.png" alt="">
      </div>
      <p class="title">教学科研条件完善，培训质量保证</p>
      <div class="black">
        <p>高质量的办学条件</p>
        <span>
          新校区位于地理位置优越、发展前景广阔的郑东新区，总占地面积1081810m2，建筑面积407290 m2.
          新的酒店式管理培训楼相继投入使用，能同时满足350人食宿，并拥有智慧教室、精品微课录播教室、标准化考场等现代化教学设施。
          老校区位于郑州火车站西广场西南侧200米，交通便利，拥有独立的学员培训中心，可容纳120人食宿教学。
          学校固定资产总值41444.92万元，其中教学仪器设备固定资产总值25416万元，生均仪器设备价值13998.37元。
          图书馆藏书116.83万册,生均图书64.93册。
          中央财政支持实训基地2个，国家级生产性实训基地2个，国家级虚拟仿真实训中心1个，国家级协同创新中心1个。
          目前新老校区的“平安校园"建设都已实施网格化管理，保证全天候校园信息实时传送,
          为学员在校培训安全提供可靠保障。
        </span>
      </div>
    </div>
    <div class="contier-4">
      <div>
        <div class="black">
          <p>高质量的教学团队</p>
          <span>
            学校设置有16个教学院（系、部），开办有工、医、文、管、经济、艺术6大类68个专业协调发展，对外合作办学设置医护类、轨道类和管理类等专业9个，形成了主干的轨道类、医护类专业，精干的人文艺术类专业布局。现有国家“双高计划”高水平专业群1个，国家级重点专业12个，国家级示范专业点4个，教育部1+X
            证书试点专业26个，教育部现代学徒制试点专业4个，国家级精品课程、资源共享课程、在线开放课程3门，国家职业教育专业教学资源库2个，国家职业教育规划教材54部。学校现有教职工977人，副高级及以上专任教师占30%，博士、硕士占77%，双师型教师占专任教师比例为86%。享受国务院特殊津贴专家1人，全国优秀教师2人，全国技术能手2人，全国行业职业教育教学指导委员会主任委员2人，全国职业教育轨道交通名师7人；拥有首批“全国高校黄大年式教师团队”1个，首批国家级职业教育教师教学创新团队1个。
            　　近年来，学校紧紧围绕国家“一带一路”倡议、国家铁路和区域经济发展战略，在全国高职院校率先实现高铁专业的全覆盖，形成了高速动车组技术等7个具有辐射带动作用的特色专业集群。高速铁道技术、铁道机车车辆、电气化铁道技术、城市轨道交通控制、城市轨道交通运营管理、铁道工程技术等专业为中央财政支持的国家骨干高职院校重点建设专业；拥有护理专业职业教育实训基地及城市轨道交通车辆实训基地两个中央财政支持的实训基地；呼吸治疗技术专业和工程机械控制技术专业被纳入中央财政支持的高等职业学校提升专业服务产业发展能力项目名录。同时，我校还是教育部和河南省专业教学改革试点单位和全国铁路专业优秀教学点，是多个省部级学术组织的牵头单位，师资力量雄厚、课程资源十分丰富，能完全满足轨道类职工的职业技能提升需求。
          </span>
        </div>
      </div>
    </div>
    <div class="contier-5">
      <div class="img-a inline">
        <img src="../assets/03.png" alt="">
      </div>
      <p class="title">教学科研条件完善，培训质量保证</p>
      <div class="menu">
        <div class="left">
          <img class="img-a" src="../assets/Rectangle73.png" alt="">
          <img class="img-b" src="../assets/Rectangle74.png" alt="">
        </div>
        <div class="right">
          <span>
            目前我校开展的各类培训项目，参培学员以技师、高级技师和技术骨干为主，以全脱产课堂教学为主，实训、参观、交流、座谈、技能练习等教学方法为辅，教学方法多样，既提高理论知识，也创新实践操作技术水平，重在提高工作中解决实际问题的能力。为更好地服务国家“一带一路”倡议和“高铁走出去”战略，我校还积极开展境外铁道车辆专业技术技能培训，培训教师团队远赴肯尼亚，为肯尼亚蒙内铁路（蒙巴萨港-内罗毕）项目培训铁路车辆运用维修人员，进一步增强了学校对外服务能力和国际化办学水平。
          </span>
        </div>
      </div>

    </div>
    <div class="contier-6">
      <div class="top">
        <span>
          　为更好地适应社会进步需求，发挥高校服务社会职能我校继续教育工作不断提高内涵建设，转变传统思维模式，创新继续教育的教学模式，实现教育管理的现代化。利用“互联网+”的开放性、重塑性、融合性特点，实现继续教育的便利性、实用性，拓展继续教育的广泛性、有效性，增强继续教育的针对性、专业性，我校自主研发了“四方联动O2O铁路技术培训平台”。该培训平台兼容性和承载力强，日培训人次可达8万人/天。线上平台+线下基地的培训模式，能充分实现线上线下的有效融合衔接，形成以需求为导向，以学习者为中心，知识和能力并重，理论和实践相结合的人才培养模式，为各类劳动者学习理论知识和职业技能提供更便捷化、多样化、个性化的服务，有效解决工学矛盾，提高市场竞争力。
        </span>
      </div>
      <img class="Ellipse" src="../assets/Ellipse7.png" alt="">
      <img class="Frame" src="../assets/Frame6.png" alt="">
    </div>
    <div class="contier-7">
      <div class="img-a inline">
        <img src="../assets/04.png" alt="">
      </div>
      <p class="title">校企合作良好，培训潜力巨大</p>
      <div class="block">

        <div class="center">
          <div class="left">
            <img src="../assets/Rectangle75.png" alt="">
          </div>
          <span>
            　学校坚持深度融入式校企合作办学。通过搭建校企合作大平台、共建二级学院及就业实习基地等途径，服务区域经济社会发展，增强办学活力。与21家铁路企业共同组建了郑州铁路高等职业教育集团；与郑州市轨道交通有限公司共建郑州市轨道交通人才培养基地；与46家企业和2家高校共同组建河南省轨道交通产业技术创新战略联盟。与郑州市轨道交通有限公司共建郑州轨道交通学院，与中兴通讯股份有限公司共建轨道通讯学院，与河南君兰影视动画有限公司共建君兰动漫学院，与宝视达眼镜（连锁）有限公司共建宝视达眼视光学院等。另外，还先后与美国通用电气GE智能平台、河南辉煌股份有限公司、郑州铁路装备制造有限公司、许继停车系统有限公司、索凌电气有限公司、河南省人民医院、郑州市食品药品监督局等单位共建实验室、实训培训及实习就业基地。学校的实践教学能力大幅提升，学生实践水平稳步提高，人才培养质量深得用人单位及社会赞誉。
          </span>
        </div>
        <div class="center">
          <span>
            　良好的校企关系造就良好的培训市场，学校紧跟企业步伐，了解企业所需，为企业提供实用的、针对性强的培训项目。我校希望能发挥自身行业特色和学科优势，对接高铁、城市轨道交通、康复护理等行业的人才需求，构建轨道交通特色职业培训体系，承担一线技能型人才的培训，大力培育新时代工匠型技能人才，为帮助轨道交通行业建设一支知识型、技术型、创新型职工队伍贡献力量。
          </span>
          <div class="right"> <img src="../assets/Rectangle76.png" alt="">
          </div>
        </div>

      </div>
    </div>
  </div>

</template>
<script>
  export default {
    name: 'introduction',
    data () {
      return {

      }
    },
  }
</script>
<style lang="scss" scoped>
  .contier-1 {
    width: 100%;
    height: 792px;
    background-image: url("../assets/Rectangle68.png");
    background-size: cover;
    position: relative;
    padding-top: 105px;

    .title {
      position: absolute;
      width: 680px;
      height: 60px;
      left: calc(50% - 680px / 2 - 1px);
      top: 210px;
      font-family: "Source Han Sans CN";
      font-style: normal;
      font-weight: 900;
      font-size: 40px;
      line-height: 60px;
      /* identical to box height */
      text-align: center;
      color: #214577;
    }
  }

  .img-a {
    img {
      margin: auto;
    }
  }

  .contier-2 {
    background: #6891ef;
    height: 400px;

    .left {
      float: left;
      width: 50%;
    }

    .right {
      width: 50%;
      float: right;
      padding: 95px 323px 95px 88px;

      span {
        font-family: "PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        line-height: 30px;
        color: #fff;
      }
    }
  }

  .contier-3 {
    position: relative;
    background-image: url("../assets/Rectangle71.png");
    height: 608px;
    padding-top: 105px;

    .title {
      position: absolute;
      width: 680px;
      height: 60px;
      left: calc(50% - 680px / 2 - 1px);
      top: 210px;
      font-family: "Source Han Sans CN";
      font-style: normal;
      font-weight: 900;
      font-size: 40px;
      line-height: 60px;
      /* identical to box height */
      text-align: center;
      color: #214577;
    }

    .black {
      width: 1180px;
      height: 312px;
      background: rgba(0, 0, 0, 0.2);
      margin: 68px auto;
      text-align: center;
      padding: 42px 160px;

      p {
        font-family: "PingFang SC";
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        color: #214577;
        margin: 10px auto;
      }

      span {
        font-size: 16px;
        line-height: 24px;
        color: #214577;
      }
    }
  }

  .contier-4 {
    height: 484px;

    .black {
      width: 1180px;
      margin: 10px auto;
      padding: 42px 160px;

      p {
        font-family: "PingFang SC";
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        color: #214577;
        margin: 10px auto;
        text-align: center;
      }

      span {
        font-size: 16px;
        line-height: 24px;
        color: #303133;
      }
    }
  }

  .contier-5 {
    width: 100%;
    height: 567px;
    background: #6891ef;
    position: relative;
    padding-top: 105px;

    .title {
      position: absolute;
      width: 680px;
      height: 60px;
      left: calc(50% - 680px / 2 - 1px);
      top: 210px;
      font-family: "Source Han Sans CN";
      font-style: normal;
      font-weight: 900;
      font-size: 40px;
      line-height: 60px;
      /* identical to box height */
      text-align: center;
      color: #fff;
    }

    .menu {
      .left {
        position: relative;
        float: left;
        width: 40%;

        .img-a {
          position: absolute;
          top: 50px;
          left: 350px;
        }

        .img-b {
          position: absolute;
          top: 122px;
          left: 500px;
        }
      }

      .right {
        width: 60%;
        float: right;
        padding: 95px 258px 95px 58px;

        span {
          font-family: "PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 16px;
          line-height: 30px;
          color: #fff;
        }
      }
    }
  }

  .contier-6 {
    height: 949px;
    position: relative;

    .top {
      width: 622px;
      height: 256px;
      background: rgba(255, 255, 255, 0.3);
      z-index: 3;
      position: absolute;
      padding: 20px;
      top: 85px;
      left: 497px;

      span {
        font-family: "PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        color: #303133;
      }
    }

    .Frame {
      position: absolute;
      top: 142px;
      right: -137px;
      z-index: 1;
    }

    .Ellipse {
      position: absolute;
      top: 132px;
      right: 0;
      z-index: 0;
    }
  }

  .contier-7 {
    height: 992px;
    position: relative;
    padding-top: 105px;

    .title {
      position: absolute;
      width: 680px;
      height: 60px;
      left: calc(50% - 680px / 2 - 1px);
      top: 210px;
      font-family: "Source Han Sans CN";
      font-style: normal;
      font-weight: 900;
      font-size: 40px;
      line-height: 60px;
      text-align: center;
      color: #214577;
    }

    .block {
      width: 1160px;
      height: 600px;
      margin: 80px auto;

      .center {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-content: space-between;
        margin-top: 68px;

        span {
          font-family: "PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 16px;
          line-height: 24px;
          color: #303133;
          margin: 0 20px;
        }

        .left {
          width: 580px;
        }

        .right {
          width: 580px;
        }
      }
    }
  }
</style>